import React from "react"

// import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps"

const darkTheme = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#242f3e" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#263c3f" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6b9a76" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }],
  },
]

interface IMapWebView {
  coordinate: {
    lat: number
    lng: number
  }
  header?: string
  isEventDetailView?: boolean
  isAdmin?: boolean
}

const MapWebView = ({
  coordinate,
  header = "Find this event",
  isEventDetailView = false,
  isAdmin = false,
}: IMapWebView) => {
  //   const { isLoaded, loadError } = useJsApiLoader({
  //     id: "google-map-script",
  //     googleMapsApiKey: "AIzaSyAouEqGmOPLYOZ5CPEHtGZY7540ObV3EEg",
  //   });
  //   console.log("🚀 ~ MapWebView ~ loadError:", loadError);

  //   const [map, setMap] = React.useState(null);

  //   const onLoad = React.useCallback(function callback(map) {
  //     // This is just an example of getting and using the map instance!!! don't just blindly copy!
  //     const bounds = new window.google.maps.LatLngBounds(center);
  //     map.fitBounds(bounds);

  //     setMap(map);
  //   }, []);

  //   const onUnmount = React.useCallback(function callback(map) {
  //     setMap(null);
  //   }, []);

  //   const isNotEmpty = (obj: object) => {
  //     if (typeof obj === "object" && Object.keys(obj).length) {
  //       return true;
  //     } else return false;
  //   };

  //   return isLoaded || loadError ? (
  //     <GoogleMap
  //       mapContainerStyle={containerStyle}
  //       center={center}
  //       zoom={10}
  //       onLoad={onLoad}
  //       onUnmount={onUnmount}
  //     ></GoogleMap>
  //   ) : (
  //     <></>
  //   );

  const MapHeaderContainer = () => {
    return (
      <h6
        className={`text-lg sm:text-xl text-start ${!isAdmin ? "text-white" : "text-white/35 sm:text-white"}`}
      >
        {header}
      </h6>
    )
  }

  if (isEventDetailView) {
    return (
      <div
        className={`mt-6 sm:mt-8 sm:bg-transparent sm:border-0 sm:px-0 sm:py-0 sm:rounded-none`}
      >
        {/* <MapHeaderContainer /> */}
        <div className="mt-4 rounded-md overflow-hidden">
          <APIProvider apiKey={import.meta.env.VITE_GOOGLE_API_KEY}>
            <Map
              defaultCenter={coordinate ?? null}
              disableDefaultUI={true}
              style={{ width: "100%", height: "200px" }}
              defaultZoom={3}
              gestureHandling="cooperative"
              draggable={true}
              scrollwheel={true}
              controlled={false}
              styles={darkTheme}
              onClick={() =>
                window.open(
                  `https://maps.google.com?q=${coordinate.lat},${coordinate.lng}`,
                )
              }
            >
              <Marker
                position={{ ...coordinate }}
                clickable
                onClick={() =>
                  window.open(
                    `https://maps.google.com?q=${coordinate.lat},${coordinate.lng}`,
                  )
                }
              />
            </Map>
          </APIProvider>
        </div>
      </div>
    )
  } else {
    return (
      <div className="mt-8">
        <MapHeaderContainer />
        <div className="mt-4 rounded-md overflow-hidden">
          <APIProvider apiKey={import.meta.env.VITE_GOOGLE_API_KEY}>
            <Map
              defaultCenter={coordinate ?? null}
              disableDefaultUI={true}
              style={{ width: "100%", height: "200px" }}
              defaultZoom={3}
              gestureHandling="cooperative"
              draggable={true}
              scrollwheel={true}
              controlled={false}
              styles={darkTheme}
              onClick={() =>
                window.open(
                  `https://maps.google.com?q=${coordinate.lat},${coordinate.lng}`,
                )
              }
            >
              <Marker
                position={{ ...coordinate }}
                clickable
                onClick={() =>
                  window.open(
                    `https://maps.google.com?q=${coordinate.lat},${coordinate.lng}`,
                  )
                }
              />
            </Map>
          </APIProvider>

          {/* <iframe
            width="600"
            height="450"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen={true}
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCzabaxdcF_Ggp8cTqJGJQ2MowR0ez7hFc&q=Space+Needle,Seattle+WA"
          ></iframe> */}
        </div>
      </div>
    )
  }
}

export default MapWebView
